import React from "react";
import {connect} from "react-redux";
import * as jotoTypes from "../../api/joto-types";
import * as joto from "../../api/joto";
import Joto from "../../api/joto";
import * as jotoui from "../../joto-ui-api"
import PropTypes from "prop-types";
import { ProjectCard } from '../project-card/ProjectCard';
import ReactTooltip from "react-tooltip";

interface OverviewPageState {
    loggedIn: string | null,
    globalProjectList: jotoTypes.Projects
}

interface OverviewPageProps extends OverviewPageState {
    joto: Joto,
    jotoui: jotoui.JotoUIApi
}

class OverviewPage_ extends React.Component<OverviewPageProps> {

    constructor(props : OverviewPageProps) {
        super(props);
        this.scrollPosition = 0;

        const projects : jotoTypes.Project[] = joto.projectArrayFromStoreAndPathArray(this.props.globalProjectList.store, this.props.globalProjectList.projectPathList);
        // noinspection UnnecessaryLocalVariableJS
        const popularProjects_: jotoTypes.Project[]  = [...projects].sort(function(a, b) {
            return b.likeCount-a.likeCount; 
        });
        this.popularProjects = popularProjects_; 

    }
    scrollPosition: number;
    popularProjects: jotoTypes.Project[] ; 

    render() {
        const projects : jotoTypes.Project[] = joto.projectArrayFromStoreAndPathArray(this.props.globalProjectList.store, this.props.globalProjectList.projectPathList);

        const newProjects: jotoTypes.Project[]  = [...projects].sort(function(a, b) {
            return b.creationTimestamp-a.creationTimestamp; 
        });

        /*
            TODO: the ReactTooltip component needs to only be included once for the whole project. I decided to do it here. See the following line of documentation:
            https://github.com/wwayne/react-tooltip: The component was designed to set <ReactTooltip /> once and then use tooltip everywhere, but a lot of people get stuck when using this component in a modal.
         */

        return (
        <div style={{marginBottom: "10rem", marginTop: "3rem"}}>
            <h1 > Beliebte Projekte </h1> 
            <hr/>
            <div className="row">
                {this.popularProjects.map((project, i) =>  (i < 4) ? (<div key={`project${i}`} className="col-12 col-xl-3 col-lg-4 col-md-6"><ProjectCard project={project} jotoui={this.props.jotoui}/></div>) : null)}
            </div>
            <h1 > Neuste Projekte </h1> 
            <hr/>
            <div className="row">
                {newProjects.map((project, i) => (i < 4) ? <div key={`project${i}`} className="col-12 col-xl-3 col-lg-4 col-md-6"><ProjectCard project={project} jotoui={this.props.jotoui}/></div> : null)}
            </div>
            <ReactTooltip className='react-tooltip-z-index'/>
        </div>
        )
    }
}
// @ts-ignore
OverviewPage_.propTypes = {
    joto: PropTypes.object.isRequired,
    jotoui: PropTypes.object.isRequired,
};


const OverviewPage_mapStateToProps = (state : jotoui.JotoUIState) : OverviewPageState => ({
    loggedIn: state.ui.loggedIn,
    globalProjectList : state.globalProjectList,
});

export const OverviewPage = connect(OverviewPage_mapStateToProps)(OverviewPage_);
